"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGGER_KEY = exports.BUILD_LOGGER_MESSAGE = void 0;
exports.BUILD_LOGGER_MESSAGE = "Logger initialized...";
exports.LOGGER_KEY = "LOGGER";
